export class Usage {
    'amount';
    'unit';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "amount",
            "baseName": "amount",
            "type": "number",
            "format": "double"
        },
        {
            "name": "unit",
            "baseName": "unit",
            "type": "UsageUnit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Usage.attributeTypeMap;
    }
    constructor() {
    }
}
